import { cartLinesStyles } from "@insite/content-library/Widgets/Cart/CartLines";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import { TYPOGRAPHY } from "@tSurya/theme/design.surya";
import { css } from "styled-components";

cartLinesStyles.headerWrapper = {
    css: css`
        /* border-bottom: 1px solid ${getColor("common.border")}; */
        padding-bottom: 8px;
        margin-top: 16px;

        > section {
            display: flex;
            justify-content: space-between;
            padding-bottom: 0px;
            align-items: flex-end;
            > span:first-of-type {
                font-family: ${TYPOGRAPHY.fontFamily.title};
                font-style: normal;
                font-weight: ${TYPOGRAPHY.weight.bold};
                font-size: ${TYPOGRAPHY.size.base};
                line-height: ${TYPOGRAPHY.lineHeight.base};
                color: #545454;
            }
        }
    `,
};

cartLinesStyles.header = {
    condensedViewCheckboxGroup: {
        css: css`
            display: none;
            margin-left: auto;
        `,
    },
    overflowMenu: {
        cssOverrides: {
            wrapper: css`
                margin-left: 20px;
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            css`
                                button {
                                    background: none;
                                    color: ${getColor("text.link")} !important;
                                }
                            `,
                            css`
                                button {
                                    background: none;
                                    color: ${getColor("text.link")} !important;
                                }
                            `,
                            css`
                                button {
                                    background: none;
                                }
                            `,
                            null,
                        ],
                        "min",
                    )}
            `,
        },
    },
    removeAllLink: {
        css: css`
            margin-left: 24px;
            font-family: ${TYPOGRAPHY.fontFamily.title};
            font-style: normal;
            font-weight: ${TYPOGRAPHY.weight.bold};
            font-size: ${TYPOGRAPHY.size.small};
            line-height: ${TYPOGRAPHY.lineHeight.base};
            color: ${getColor("text.link")};
        `,
    },
};

cartLinesStyles.footerWrapper = {
    css: css`
        display: flex;
        justify-content: flex-end;
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    css`
                        justify-content: center;
                    `,
                    css`
                        justify-content: center;
                    `,
                    css`
                        justify-content: center;
                    `,
                    css`
                        justify-content: flex-end !important;
                    `,
                ],
                "min",
            )}
    `,
};

cartLinesStyles.backToTopButton = {
    variant: "secondary",
    css: css`
        margin: 16px 0 24px 0;
        font-family: ${TYPOGRAPHY.fontFamily.title};
        font-style: normal;
        font-weight: ${TYPOGRAPHY.weight.baseBold};
        font-size: ${TYPOGRAPHY.size.base};
        line-height: ${TYPOGRAPHY.lineHeight.xbase};
        color: #323132;
        border: 1px solid #323132;
        border-radius: 0;
        > span {
            font-family: ${TYPOGRAPHY.fontFamily.title};
            font-style: normal;
            font-weight: ${TYPOGRAPHY.weight.baseBold};
            font-size: ${TYPOGRAPHY.size.base};
            line-height: ${TYPOGRAPHY.lineHeight.xbase};
            color: #323132;
        }
        &:hover {
            color: #323132 !important;
            border: 1px solid #323132 !important;
            background-color: transparent !important;
        }
        &:hover > span {
            color: #323132 !important;
        }
    `,
};
